import {IStoreState} from "../types";

export const getCurrentNetworkingRoom = (state: IStoreState) => state.networking.networkingRoom;
